/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ZerogTokenSummaryInfo } from './ZerogTokenSummaryInfo';

export type ZerogTokenInfo = {
    ADDR: ZerogTokenSummaryInfo;
    TKNT: ZerogTokenInfo.TKNT;
    PRC: string;
    PRC24H: string;
    MKC: string;
    VOL24H: string;
    HD: string;
    HD24H: string;
};

export namespace ZerogTokenInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

